export { default as ShopResume } from './ShopResume';
